import CodeMirror from "codemirror";
import tryToJSON from "utils/try-to-json";

// Based on http://codemirror.net/addon/runmode/runmode.js
// Licensed under MIT
CodeMirror.runMode = function (string, mode, callback, options) {
  var ie = /MSIE \d/.test(navigator.userAgent);
  var ie_lt9 =
    ie && (document.documentMode == null || document.documentMode < 9);
  if (callback.nodeType == 1) {
    var tabSize = (options && options.tabSize) || CodeMirror.defaults.tabSize;
    var node = callback,
      col = 0;
    node.innerHTML = "";
    callback = function (text, style) {
      if (text === "\n") {
        // Emitting LF or CRLF on IE8 or earlier results in an incorrect display.
        // Emitting a carriage return makes everything ok.
        node.appendChild(document.createTextNode(ie_lt9 ? "\r" : text));
        col = 0;
        return;
      }

      var tabs = text.split("\t");
      for (var i = 0; i < tabs.length; i++) {
        if (i % 2 === 0) {
          if (style) {
            style = tryToJSON(style);
            var sp = node.appendChild(document.createElement("span"));
            sp.className =
              "cm-" + (style?.placeHolder || style).replace(/ +/g, " cm-");
            if (style.preString) {
              sp.setAttribute("data-preString", style.preString);
            }
            sp.appendChild(document.createTextNode(tabs[i]));
          } else {
            node.appendChild(document.createTextNode(tabs[i]));
          }
          col += tabs[i].length;
        } else {
          var size = tabSize - (col % tabSize);
          var tab = node.appendChild(document.createElement("span"));
          tab.className = "cm-tab";
          tab.setAttribute("role", "presentation");
          tab.setAttribute("cm-text", "\t");
          tab.appendChild(
            document.createTextNode(new Array(size + 1).join(" ")),
          );
          col += size;
        }
      }
    };
  }

  const preStreams = [];
  var i, e;
  if (options?.preString) {
    if (options?.forceBreak) {
      options.preString += "\n";
    }
    var preStringLines = CodeMirror.splitLines(options.preString),
      preState = (options && options.state) || CodeMirror.startState(mode);
    for (i = 0, e = preStringLines.length; i < e; ++i) {
      var preStream = new CodeMirror.StringStream(preStringLines[i]);
      while (!preStream.eol()) {
        mode.token(preStream, preState);
        preStreams.push(preStream.current());
        preStream.start = preStream.pos;
      }
    }
  }

  const lastString = string;
  const fullString = (options?.preString || "") + string;
  var lines = CodeMirror.splitLines(fullString),
    state = (options && options.state) || CodeMirror.startState(mode);
  const currentStreams = [];
  for (i = 0, e = lines.length; i < e; ++i) {
    if (i && !options?.forceBreak) callback("\n");

    var stream = new CodeMirror.StringStream(lines[i]);
    if (!stream.string && mode.blankLine) mode.blankLine(state);
    while (!stream.eol()) {
      const style = mode.token(stream, state);
      const currentString = stream.current();
      const start = stream.start;

      currentStreams.push({
        currentString,
        style,
        i,
        start,
        state: { ...state },
      });

      stream.start = stream.pos;
    }
  }

  if (currentStreams.length - preStreams.length !== 0) {
    const abc = currentStreams.slice(
      -1 * (currentStreams.length - preStreams.length),
    );
    abc.forEach(str => {
      callback(str.currentString, str.style, str.i, str.start, str.state);
    });
  } else {
    const str = currentStreams.splice(-1)[0];
    if (fullString === options?.preString) {
      callback("", str.style, str.i, str.start, str.state);
    } else {
      callback(lastString, str.style, str.i, str.start, str.state);
    }
  }

  return state;
};
